module.exports = __webpack_public_path__ + "static/media/task-warning-icon.e1319d46.svg";